import React, { useMemo, useState } from 'react';
import {
    Button,
    Box,
    Grid,
    FormControlLabel,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Zoom,
    Radio,
    RadioGroup,
    FormLabel,
} from '@mui/material';
import Dropzone from 'react-dropzone';
import { useDropzone } from 'react-dropzone';
import unsplash from '../api/unsplash';
import Upload from '@mui/icons-material/Upload';
import { Check, Close } from '@mui/icons-material';
import GlobalSnackbar from './Snackbar';
import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';
import moment from 'moment';
import 'moment/locale/it';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const ProceduraFileUploader = (props) => {
    const [open, setOpen] = useState(false);
    const { isDragAccept, isDragReject, isFocused } = useDropzone();
    const [files, setFiles] = useState([]);
    const [openSnack, setOpenSnack] = useState(false);
    const [assegnaA, setAssegnaA] = useState(0);
    const [lavoratori, setLavoratori] = useState([]);
    const [mansioniSicurezza, setMansioniSicurezza] = useState([]);
    const [listaSel, setListaSel] = useState([]);

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });

    const baseStyle = useMemo(
        () => ({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px',
            borderWidth: 2,
            borderRadius: 2,
            borderColor: '#eeeeee',
            borderStyle: 'dashed',
            backgroundColor: '#fafafa',
            color: '#bdbdbd',
            outline: 'none',
            transition: 'border .24s ease-in-out',
        }),
        []
    );

    const focusedStyle = useMemo(
        () => ({
            borderColor: '#2196f3',
        }),
        []
    );

    const acceptStyle = useMemo(
        () => ({
            borderColor: '#00e676',
        }),
        []
    );

    const rejectStyle = useMemo(
        () => ({
            borderColor: '#ff1744',
        }),
        []
    );

    const handleUpload = async () => {
        if (files.length === 0) {
            setSnack({
                severity: 'error',
                messaggio: 'Nessun file selezionato',
            });
            setOpenSnack(true);
        } else if (props.visiteMedicheLavoratore) {
            if (files.length > 1) {
                setSnack({
                    severity: 'error',
                    messaggio: 'Carica solo un file',
                });
                setOpenSnack(true);
            } else {
                const formData = new FormData();
                formData.append('description', props.description);
                formData.append('colonna', props.colonna);
                formData.append('ID', props.id);
                formData.append('colonnaExtra', props.colonnaExtra);
                formData.append('extra', props.extra);
                formData.append('assegnaA', assegnaA);
                formData.append(
                    'listaSel',
                    JSON.stringify(listaSel.map((el) => el.ID))
                );
                files.map((file) => {
                    return formData.append('file', file);
                });
                try {
                    const res = await unsplash.post(
                        'caricaDocProcedure',
                        formData,
                        {
                            headers: {
                                'content-type': 'multipart/form-data',
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    );

                    console.log(res);

                    setSnack({
                        severity: 'success',
                        messaggio: 'File caricato con successo',
                    });
                    setOpenSnack(true);
                    setOpen(false);
                    //props.reloadAfterUpload();
                } catch {
                    setSnack({
                        severity: 'error',
                        messaggio: 'Errore durante il caricamento',
                    });
                    setOpenSnack(true);
                }
            }
        } else {
            const formData = new FormData();
            formData.append('colonna', props.colonna);
            formData.append('ID', props.id);
            if (
                props.hasOwnProperty('colonnaExtra') &&
                props.colonnaExtra !== undefined &&
                props.colonnaExtra !== ''
            ) {
                formData.append('colonnaExtra', props.colonnaExtra);
                formData.append('extra', props.extra);
            }
            formData.append('assegnaA', assegnaA);
            formData.append(
                'listaSel',
                JSON.stringify(listaSel.map((el) => el.ID))
            );

            files.map((file) => {
                return formData.append('file', file);
            });
            try {
                const doc = await unsplash.post(
                    'caricaDocProcedure',
                    formData,
                    {
                        headers: {
                            'content-type': 'multipart/form-data',
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );
                console.log(doc);
                setSnack({
                    severity: 'success',
                    messaggio: 'File caricato con successo',
                });
                setOpenSnack(true);
                props.reloadAfterUpload();
                setOpen(false);
            } catch {
                setSnack({
                    severity: 'error',
                    messaggio: 'Errore durante il caricamento',
                });
                setOpenSnack(true);
            }
        }
    };

    const handleClose = () => {
        setOpen(false);
    };
    const onDrop = (acceptedFiles) => {
        setFiles(acceptedFiles);
    };

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [
            isFocused,
            isDragAccept,
            isDragReject,
            acceptStyle,
            baseStyle,
            focusedStyle,
            rejectStyle,
        ]
    );

    const loadLavoratori = async () => {
        const lav = await unsplash.get('lavoratori', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
            params:
                props.colonna === 'Sede'
                    ? {
                          clienteId: props.extra,
                          sedeId: props.id,
                          dettaglioSedi: true,
                      }
                    : { id: props.idAzienda },
        });

        setLavoratori(
            lav.data.data.filter(
                (v) =>
                    !v.DataTermine ||
                    moment(v.DataTermine).format('YYYY-MM-DD') >
                        moment(new Date()).format('YYYY-MM-DD')
            )
        );
    };

    const loadMansioneSicurezza = async () => {
        let responseMansioniSicurezza = await unsplash.get(
            'mansioniSicurezza',
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: { id: props.extra, sede: props.id }, //extra è il cliente, id è lasede
            }
        );
        setMansioniSicurezza(responseMansioniSicurezza.data.data);
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />

            <Button
                className="ButtonMiller"
                startIcon={<Upload />}
                onClick={async () => {
                    await loadLavoratori();
                    if (props.colonna === 'Sede') {
                        await loadMansioneSicurezza();
                    }

                    setAssegnaA(0);
                    setOpen(true);
                    setFiles([]);
                }}
            >
                Procedura
            </Button>

            <Dialog
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <DialogTitle>Carica Procedura</DialogTitle>
                <DialogContent>
                    <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles)}>
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps({ style })}>
                                <input {...getInputProps()} />
                                <p>
                                    Trascina e rilascia qui o fai clic per
                                    selezionare i file
                                </p>
                            </div>
                        )}
                    </Dropzone>
                    <FormLabel id="demo-form-control-label-placement">
                        Assegna a
                    </FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-form-control-label-placement"
                        name="position"
                        defaultValue="top"
                    >
                        <FormControlLabel
                            value="end"
                            control={
                                <Radio
                                    checked={assegnaA === 0}
                                    onChange={() => setAssegnaA(0)}
                                />
                            }
                            label="Tutti"
                        />
                        <FormControlLabel
                            value="end"
                            control={
                                <Radio
                                    checked={assegnaA === 1}
                                    onChange={() => setAssegnaA(1)}
                                />
                            }
                            label="Lavoratori"
                        />

                        {props.colonna === 'Sede' && (
                            <FormControlLabel
                                value="end"
                                control={
                                    <Radio
                                        checked={assegnaA === 2}
                                        onChange={() => setAssegnaA(2)}
                                    />
                                }
                                label="Mansione"
                            />
                        )}
                    </RadioGroup>
                    {assegnaA === 1 && (
                        <DialogLavoratori
                            lavoratori={lavoratori}
                            idAzienda={props.idAzienda}
                            setListaSel={setListaSel}
                        />
                    )}
                    {assegnaA === 2 && (
                        <DialogMansioni
                            setListaSel={setListaSel}
                            mansioniSicurezza={mansioniSicurezza}
                            idAzienda={props.idAzienda}
                        />
                    )}
                    <aside>
                        <h4 style={{ marginTop: '10px', textAlign: 'center' }}>
                            Files
                        </h4>
                        {files?.map((file) => {
                            return (
                                <>
                                    <ul
                                        style={{
                                            textAlign: 'center',
                                            padding: 0,
                                        }}
                                    >
                                        {file.path}
                                    </ul>
                                </>
                            );
                        })}
                    </aside>
                </DialogContent>
                <DialogActions
                    xs={12}
                    item
                    sx={{
                        display: 'flex',
                        mt: 2,
                        justifyContent: 'space-between',
                        px: 2,
                    }}
                    fullWidth
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Annulla
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Upload />}
                        onClick={handleUpload}
                    >
                        Carica
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ProceduraFileUploader;

const DialogLavoratori = ({ lavoratori, idAzienda, setListaSel }) => {
    const [open, setOpen] = useState(false);
    const [lavoratoriSelezionati, setLavoratoriSelezionati] = useState([]);
    const handleClose = () => {
        setOpen(false);
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }

    const columns = [
        { field: 'SedeDesc', headerName: 'Sede', width: 150 },
        { field: 'Cognome', headerName: 'Cognome', width: 150 },
        { field: 'Nome', headerName: 'Nome', width: 150 },
        { field: 'CF', headerName: 'CF', width: 200 },

        { field: 'Qualifica', headerName: 'Qualifica', width: 150 },
        { field: 'Livello', headerName: 'Livello', width: 150 },
        { field: 'TipoRapporto', headerName: 'TipoRapporto', width: 200 },
        {
            field: 'TipoPartTime',
            headerName: 'TipoPartTime',
            width: 300,
        },
        {
            field: 'CentroDiCosto',
            headerName: 'CentroDiCosto',
            width: 300,
        },
        { field: 'Note', headerName: 'Note', width: 300 },
    ];

    const handleConfirm = () => {
        setListaSel(lavoratoriSelezionati);
        setOpen(false);
    };
    return (
        <>
            <Button
                className="ButtonMiller"
                onClick={async () => {
                    setOpen(true);
                }}
            >
                Seleziona Lavoratori
            </Button>

            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <DialogTitle>Seleziona Lavoratori</DialogTitle>
                <DialogContent>
                    <Box sx={{ height: '60vh', width: '100%' }}>
                        <DataGridPro
                            components={{
                                Toolbar: CustomToolbar,
                                Footer: CustomFooterPersonalized,
                            }}
                            disableSelection={true}
                            localeText={
                                itIT.components.MuiDataGrid.defaultProps
                                    .localeText
                            }
                            rows={lavoratori}
                            getRowId={(lavoratori) => lavoratori.ID}
                            columns={columns}
                            onSelectionModelChange={(ids) => {
                                const selectedIDs = new Set(ids);
                                const selectedRowData = lavoratori.filter(
                                    (row) =>
                                        selectedIDs.has(row.ID) &&
                                        (!row.IDDistacco ||
                                            row.Cliente === idAzienda)
                                );
                                setLavoratoriSelezionati(selectedRowData);
                            }}
                            checkboxSelection
                        />
                    </Box>
                </DialogContent>
                <DialogActions
                    xs={12}
                    item
                    sx={{
                        display: 'flex',
                        mt: 2,
                        justifyContent: 'space-between',
                        px: 2,
                    }}
                    fullWidth
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Annulla
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Check />}
                        onClick={handleConfirm}
                    >
                        Conferma
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const DialogMansioni = ({ mansioniSicurezza, idAzienda, setListaSel }) => {
    const [open, setOpen] = useState(false);
    const [mansioniSelezionate, setMansioniSelezionate] = useState([]);
    const handleClose = () => {
        setOpen(false);
    };
    const handleConfirm = () => {
        setListaSel(mansioniSelezionate);
        setOpen(false);
    };
    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }

    const columns = [
        { field: 'Descrizione', headerName: 'Descrizione', flex: 1 },
    ];

    return (
        <>
            <Button
                className="ButtonMiller"
                onClick={async () => {
                    setMansioniSelezionate([]);
                    setOpen(true);
                }}
            >
                Seleziona Mansioni
            </Button>

            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <DialogTitle>Seleziona Mansioni</DialogTitle>
                <DialogContent>
                    <Box sx={{ height: '60vh', width: '100%' }}>
                        <DataGridPro
                            components={{
                                Toolbar: CustomToolbar,
                                Footer: CustomFooterPersonalized,
                            }}
                            checkboxSelection
                            localeText={
                                itIT.components.MuiDataGrid.defaultProps
                                    .localeText
                            }
                            rows={mansioniSicurezza}
                            getRowId={(mansione) => mansione.ID}
                            columns={columns}
                            onSelectionModelChange={(ids) => {
                                const selectedIDs = new Set(ids);
                                const selectedRowData =
                                    mansioniSicurezza.filter((row) =>
                                        selectedIDs.has(row.ID)
                                    );
                                setMansioniSelezionate(selectedRowData);
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions
                    xs={12}
                    item
                    sx={{
                        display: 'flex',
                        mt: 2,
                        justifyContent: 'space-between',
                        px: 2,
                    }}
                    fullWidth
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Annulla
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Check />}
                        onClick={handleConfirm}
                    >
                        Conferma
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

/*

	const handleUploadTemp = async () => {
		
		const formData = new FormData();
		formData.append('visitaMedica', 58134);
		formData.append('lavoratore', 30201);
		

		files.map((file) => {
			formData.append('file', file);
		});
		try {
			await unsplash.post('caricaDocCrypt', formData, {
				headers: {
					'content-type': 'multipart/form-data',
					Authorization: `Bearer ${localStorage.getItem('jwt')}`,
				},
			});
			setSnack({
				severity: 'success',
				messaggio: 'File caricato con successo',
			});
			setOpenSnack(true);
			//props.reloadAfterUpload();
		} catch {
			setSnack({
				severity: 'error',
				messaggio: 'Errore durante il caricamento',
			});
			setOpenSnack(true);
		}

}

*/
